/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchNewsFeedItemsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.NewsFeedsPaginationInput>;
}>;


export type FetchNewsFeedItemsQuery = { __typename?: 'Query', newsFeeds?: Array<{ __typename?: 'NewsFeed', id: string, title: string, description: string, linkUrl?: string | null, imageUrl?: string | null } | null> | null };


export const FetchNewsFeedItemsDocument = gql`
    query fetchNewsFeedItems($pagination: NewsFeedsPaginationInput) {
  newsFeeds(pagination: $pagination) {
    id
    title
    description
    linkUrl
    imageUrl
  }
}
    `;

/**
 * __useFetchNewsFeedItemsQuery__
 *
 * To run a query within a React component, call `useFetchNewsFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNewsFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNewsFeedItemsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFetchNewsFeedItemsQuery(baseOptions?: Apollo.QueryHookOptions<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>(FetchNewsFeedItemsDocument, options);
      }
export function useFetchNewsFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>(FetchNewsFeedItemsDocument, options);
        }
export function useFetchNewsFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>(FetchNewsFeedItemsDocument, options);
        }
export type FetchNewsFeedItemsQueryHookResult = ReturnType<typeof useFetchNewsFeedItemsQuery>;
export type FetchNewsFeedItemsLazyQueryHookResult = ReturnType<typeof useFetchNewsFeedItemsLazyQuery>;
export type FetchNewsFeedItemsSuspenseQueryHookResult = ReturnType<typeof useFetchNewsFeedItemsSuspenseQuery>;
export type FetchNewsFeedItemsQueryResult = Apollo.QueryResult<FetchNewsFeedItemsQuery, FetchNewsFeedItemsQueryVariables>;